import { Flex, Text } from "@chakra-ui/react";
import { useLocation, useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";

// One placeholder used by both the public consumer view (GX-3639) and the
// owner edit/new screens (GX-3644). The copy adjusts to which one is missing
// so it's obvious from the page which ticket finishes the work.
export default function ReadingListPlaceholder() {
  const [t] = useTranslation();
  const { listId } = useParams();
  const { pathname } = useLocation();
  const isEdit = pathname.includes("/edit") || pathname.endsWith("/new");
  const title = isEdit
    ? t("screens.shelf.readingLists.placeholder.editTitle")
    : t("screens.shelf.readingLists.placeholder.viewTitle");
  const body = isEdit
    ? t("screens.shelf.readingLists.placeholder.editBody")
    : listId
      ? t("screens.shelf.readingLists.placeholder.viewBodyWithId", { listId })
      : t("screens.shelf.readingLists.placeholder.viewBody");

  return (
    <Flex direction="column" gap="8px" px={{ base: "16px", lg: 0 }} py="48px">
      <Text fontSize="24px" fontWeight="700" color="dune.dune">
        {title}
      </Text>
      <Text fontSize="14px" color="neutral.300">
        {body}
      </Text>
    </Flex>
  );
}
